import { useState, useCallback } from "react";
import { AgGrid } from "@jsq/ds/core";
import { TicketRowItem } from "../types";

const CLICKABLE_LINK_COLUMNS = ["key"];

export const useWorkflowSlideoutDrawer = () => {
  const [selectedWorkflow, setSelectedWorkflow] = useState<TicketRowItem | undefined>(
    undefined,
  );

  const onCellClicked = useCallback((event: AgGrid.CellClickedEvent<TicketRowItem>) => {
    const columnId = event.column?.getColId();
    if (CLICKABLE_LINK_COLUMNS.includes(columnId)) {
      return;
    }

    if (event.data) {
      setSelectedWorkflow(event.data);
    }
  }, []);

  const onClose = useCallback(() => {
    setSelectedWorkflow(undefined);
  }, []);

  return { selectedWorkflow, onClose, onCellClicked };
};
